var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrevius(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.485,
    height: 14.143,
    viewBox: "0 0 8.485 14.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3609",
    "data-name": "Group 3609",
    transform: "translate(10715.071 -8265.929)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1941",
    "data-name": "Rectangle 1941",
    width: 2,
    height: 10,
    rx: 1,
    transform: "translate(-10706.586 8278.657) rotate(135)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1942",
    "data-name": "Rectangle 1942",
    width: 2,
    height: 10,
    rx: 1,
    transform: "translate(-10708 8265.929) rotate(45)",
    fill: "#434343"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevius);
export default __webpack_public_path__ + "static/media/Previus.ad174d86dd8a9b622632d98fb78c8b38.svg";
export { ForwardRef as ReactComponent };